export function getSkus(item) {
    if (!item) {
        return [];
    }
    if (typeof item === 'string') {
        return [item];
    }
    return item.variants.map((v) => v.sku);
}
export function temporaryItem(sku, pathName) {
    return {
        sku,
        pathName,
        imageUrl: '',
        name: '',
        nameLocalized: '',
        addedAt: Date.now(),
        price: {
            amount: 0,
            currencyCode: '00',
        },
        discountedPrice: {
            amount: 0,
            currencyCode: '00',
        },
    };
}
